// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"360":"d5fcd19f","484":"57d6a33d","643":"a64f7b4d","673":"0dcd6e7a","820":"aca830d1","845":"71fdc10e","864":"22de3a00","991":"e60d64e2"}[chunkId] + ".js";
};